/* eslint-disable no-unused-vars */
export enum GrantType {
  PASSWORD = 'password',
  REFRESH_TOKEN = 'refresh_token',
}
